import { Component, OnInit, ViewChild, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, MatDialog, MatDialogConfig } from '@angular/material';
import { RequetsEvaluator } from './shared/requets-evaluator.model';
import { SaveDescriptionDialogComponent } from '../../core/modal/save-description-dialog/save-description-dialog.component';
import { AssesmentsService } from './shared/assesments.service';
import { DeclineAssigment } from './shared/decline-assigment.model';
import { ConfirmationDialogComponent } from '../../core/modal/confirmation-dialog/confirmation-dialog.component';
import { Request } from '../requets/shared/model/request.model';
import { RequestReponse } from '../requets/shared/model/request-reponse.model';
import { Program } from '../programs/shared/program.model';
import { Faculty } from '../programs/shared/faculty.model';
import { Router } from '@angular/router';



@Component({
  selector: 'app-assessments',
  templateUrl: './assessments.component.html',
  styleUrls: ['./assessments.component.scss']
})
export class AssessmentsComponent implements OnInit, OnChanges {
  displayedColumns: string[] = ['codigo', 'tiposolicitud', 'cedula',
                                'falcutad', 'programa', 'version', 'tipo',
                                'estado', 'operaciones'];
  dataSource: MatTableDataSource<RequetsEvaluator>;
  messageError: String = '';
  claseMessage: String = 'messaje-error';
  @Input() requets: RequetsEvaluator[];

  @Output()
  sendSearchRequest: EventEmitter<any> = new EventEmitter();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private dialog: MatDialog,
              private router: Router,
              private assessmentsService: AssesmentsService) {
    this.setTable();

   }

  ngOnInit() {
    this.setTable();
  }

  ngOnChanges() {
    this.setTable();
  }

  decline(row: RequetsEvaluator) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { tittle: 'Mensaje Confirmación', message: '¿Esta seguro que desea declinar la Solicitud?'};
    dialogConfig.width = '30%';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
        if (value === 1) {
          this.openDialogDecline(row);
        }
    });

  }

  evaluate(row: RequetsEvaluator) {
    const request = this.generateRequest(row);
    const param = JSON.stringify(request);
    if (row.tipoSolictud === 'PRUEBA LENGUA EXTRANJERA') {
       this.router.navigate(['evaluaciones/asignar-evaluador-materias'], { queryParams: { request : param , isEvaluation : true} });
    } else {
      localStorage.setItem('request', param);
      this.router.navigate(['evaluaciones/evaluar'], { queryParams: { request : param } });
    }
  }

  private generateRequest(row: RequetsEvaluator): RequestReponse {
    const request = new RequestReponse();
    request.nombreEstudiante = row.nombreEstudiante;
    const solicitud = new Request();
    solicitud.cedula = row.identificacion;
    solicitud.solicitud =  row.solicitud;
    solicitud.tipo = row.tipoSolictud;
    const dateAux: String = row.fechaSolicitud + '';
    const dateSplit = dateAux.split('/');
    solicitud.fecha = new Date(parseInt(dateSplit[2], 10), parseInt( dateSplit[1], 10) - 1, parseInt(dateSplit[0], 10));
    request.solicitud = solicitud;
    const programas = new Program();
    programas.codigo = Number(row.codigoPrograma);
    programas.nombre =  row.nombrePrograma;
    programas.version = row.version;
    const facultad = new Faculty();
    facultad.codigo = '';
    facultad.nombre =  row.nombreFacultad;
    programas.facultad = facultad;
    request.programa = programas;
    return request;

  }

  private openDialogDecline (row: RequetsEvaluator) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data =  { tittle: 'DECLINAR ASIGNACIÓN COMO EVALUADOR', filedName: 'Justificación' };
    dialogConfig.width = '40%';
    const dialogRef = this.dialog.open(SaveDescriptionDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if (value !== null) {
          const decline = new DeclineAssigment();
          decline.solicitud = row.solicitud;
          decline.justificacion = value;
          this.assessmentsService.declineAssigment(decline).subscribe(
            (result) => {
              if (result.data) {
                if (result.data === 'OK') {
                  const index = this.requets.indexOf(row);
                  if (index > -1) {
                    this.requets.splice(index, 1);
                    this.setTable();
                 }
                  this.claseMessage = 'messaje-success';
                  this.messageError = 'Se declino la solicitud #' + row.solicitud;
                } else {
                  this.claseMessage = 'messaje-error';
                  this.messageError = result.data;
                }
              }
            }
          );
      }
    });
  }

  private setTable() {
    this.dataSource = new MatTableDataSource(this.requets);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

  }

}
